export default __webpack_public_path__ + "static/media/tooltip_grey_icon.02156aab.svg";